import type { FaireProductEntity } from "../../entity_types/product";

export const p_21k3o6rnph: FaireProductEntity = {
  token: "p_21k3o6rnph",
  type: "product",
  name: "Teakwood & Tobacco - 7.75 oz Room & Linen Spray",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/53f278d3ffc032ee8a7174081146448462989b460e3246249b6b2749616aa7fe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bf082f097c189734c63496f1d49e0d85bf5e5f32d9206f962315089448a83c00.webp",
    "https://cdn.faire.com/fastly/901702eef99a8fffb3a88910ad0ab4ba43db46d149b218c68872f5658b7c8fcf.jpeg",
    "https://cdn.faire.com/fastly/94a31a33276761f5b36b9ea5399d8e44e9e69d88752c6523d8a03ae327d8d7d2.jpeg",
    "https://cdn.faire.com/fastly/13db08b780cc750e852f02c52e31fd039a2b76c0bcb7e9650aba1e57d090201c.jpeg",
    "https://cdn.faire.com/fastly/c8204198990372227fbca763174af767f6553facc4394d12aa05d2aec7aa9d35.jpeg",
    "https://cdn.faire.com/fastly/92c380a966cb4b7aa888644ea633272196abffc9515d6589e28c4e7bc1f82fdd.jpeg",
    "https://cdn.faire.com/fastly/bc5a0c814899f777c13d6bdd067084d1a868270b280ceb550a2f0c344844dee1.jpeg",
  ],
  priceDollars: 10,
  description:
    "The one that started it all. Some call it the boyfriend scent, we call it the O.G. Leather, teak, and orange.\n\nOur Room & Linen Sprays offer an effortless, fine mist with a light fragrance! Meant for daily use on bedsheets, pillows, couches - anywhere that needs a bit of a boost. \n\nFragrance lasts longest when applied directly onto fabrics, especially any with a thicker weave.\n\nEach 7.75 oz amber bottle contains water, phthalate-free premium fragrance oil (body safe), and two cosmetic-grade preservatives meant to maintain quality and prolong shelf-life: phenoxyethanol and caprylyl glycol.\n\n",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:48.652Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
